import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CreateRole, Role, UpdateRole } from '../models/role.model';
import { PagedResult } from '../models/external-sync.model';

@Injectable({ providedIn: 'root' })
export class RoleService {
  private http = inject(HttpClient);
  private url = `${environment.rpsApiUrl}/api/roles`;

  getAll() { return this.http.get<Role[]>(this.url); }
  getPaged(page: number, pageSize: number, search?: string) {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    if (search) params = params.set('search', search);
    return this.http.get<PagedResult<Role>>(`${this.url}/paged`, { params });
  }
  getById(id: string) { return this.http.get<Role>(`${this.url}/${id}`); }
  create(dto: CreateRole) { return this.http.post<Role>(this.url, dto); }
  update(id: string, dto: UpdateRole) { return this.http.put<Role>(`${this.url}/${id}`, dto); }
  delete(id: string) { return this.http.delete(`${this.url}/${id}`); }
}
